// extracted by mini-css-extract-plugin
module.exports = {"link":"_32bbee5fda--link--Kd7LB","link-simplified":"_32bbee5fda--link-simplified--LftmI","title":"_32bbee5fda--title--t0Ggq"};